// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// NgRx actions
import { setCustomPDFReportBuilderStore } from '../custom-pdf-report-builder/custom-pdf-report-builder.action';
import { setReportCategory } from './report-category.action';
export const report_category = createReducer(null, on(setCustomPDFReportBuilderStore, setReportCategory, (state, action) => {
    return action.report_category;
}));
